import { Slider, Typography } from "@mui/material"
import React, { useEffect, useRef } from "react"
import { FlexBox } from "ui/components/FlexBox"
import { IUIConfigurationFontWeights } from "ui/configuration/model"
import { IUIConfiguration } from "../model"
import { setTempUiConfigUndoRedo } from "../tools/undo-redo"

interface IUiConfigFontWeightProps {
  uiConfig: IUIConfiguration
  configKey: keyof IUIConfigurationFontWeights
}

export const UiConfigFontWeight = React.memo(({ uiConfig, configKey }: IUiConfigFontWeightProps) => {
  const [value, setValue] = React.useState(uiConfig.font[configKey])
  const timeoutRef = useRef<any>(undefined)
  // triggered when weight change in store
  useEffect(() => {
    if (uiConfig.font[configKey] !== value) {
      setValue(uiConfig.font[configKey])
    }
  }, [uiConfig.font[configKey]])
  const changeValue = (newValue: number) => {
    setValue(newValue)
    setTempUiConfigUndoRedo({
      ...uiConfig,
      font: {
        ...uiConfig.font,
        [configKey]: newValue
      }
    })
  }
  return (
    <FlexBox gap jc="start" wrap fullWidth>
      <Typography color="textPrimary" fontSize=".9rem" sx={{ width: "10rem" }}>{`Weight ${configKey.substring(
        6
      )}`}</Typography>
      <Slider
        aria-label="Font weigth"
        value={value}
        valueLabelDisplay="on"
        step={100}
        marks
        min={100}
        max={900}
        sx={{ width: "15rem" }}
        onChangeCommitted={(_event, newValue) => {
          clearTimeout(timeoutRef.current)
          timeoutRef.current = setTimeout(() => changeValue(newValue as number), 500)
        }}
      />
      <Typography color="textPrimary" fontSize=".9rem" fontWeight={value}>
        Lorem
      </Typography>
      <Typography color="textSecondary" fontSize=".9rem" fontWeight={value}>
        Ipsum
      </Typography>
    </FlexBox>
  )
})
